import { ShieldCheckIcon } from 'lucide-react'
import { GetCollectionTemplatesPageData } from '@indigohive/cogfy-types/endpoints/getCollectionTemplatesPage'
import { Provider } from '@indigohive/cogfy-providers'
import { CogfyAvatarGrey } from '../CogfyAvatarGrey'

export type TemplateCardProps = {
  providers?: {
    name: Provider["name"]
    image: string
  }[]
  template: GetCollectionTemplatesPageData
  Anchor: React.ElementType<any>
  AnchorProps?: Record<string, any>
}

export function TemplateCard (props: TemplateCardProps) {
  const { providers, template, Anchor, AnchorProps } = props

  const tags = template.tags?.sort((a, b) => a.order - b.order) || []
  const visibleTags = tags.slice(0, 2)
  const hiddenTags = tags.slice(2)

  return (
    <Anchor {...AnchorProps}>
      <div className="card relative">
        <div className="avatar-group -space-x-4  absolute left-4 -top-5 z-10">
          {providers?.map(provider => (
            <div key={provider.name} className="avatar rounded border-none">
              <div className="size-10 rounded-lg border bg-white border-white border-3">
                <img
                  className="rounded"
                  src={provider.image}
                  alt={provider.name}
                />
              </div>
            </div>
          ))}
        </div>
        <figure className="relative">
          <img
            src={template?.mainImage?.url ?? '/cogfy-avatar-grey.svg'}
            alt={template.name ?? 'template'}
            className="hover:opacity-80 rounded-lg transition-opacity border border-primary-content/40 w-full h-52 object-cover"
          />
          <div className="absolute bottom-4 left-4 flex gap-1">
            {visibleTags.map((tag) => (
              <div
                key={tag.id}
                className="px-2 py-1 rounded-lg bg-primary text-primary-content text manrope-regular"
              >
                {tag.name}
              </div>
            ))}
            {hiddenTags.length > 0 && (
            <div className="tooltip manrope-regular" data-tip={hiddenTags.map(tag => tag.name).join(', ')}>
              <div className="px-2 py-1 rounded-lg bg-primary text-primary-content text cursor-pointer manrope-regular">
                +{hiddenTags.length}
              </div>
            </div>
            )}
          </div>
        </figure>
        <div className="card-body px-1 py-2">
          <div className="flex flex-row items-center gap-4">
            <div className="avatar relative">
              <div className="size-8 rounded-full">
                <CogfyAvatarGrey className="bg-black/90" />
              </div>
              <ShieldCheckIcon className="fill-blue-500 stroke-white absolute -bottom-2 -right-2"/>
            </div>

            <div>
              <h2 className="card-title text-neutral text-xl manrope-bold">{template.name}</h2>
              <h4 className="text-neutral text-sm manrope-regular opacity-70">Cogfy team</h4>
            </div>
          </div>
          <p className="text-neutral opacity-70 text-base manrope-regular line-clamp-2 pl-12">
            {template.description}
          </p>
        </div>
      </div>
    </Anchor>
  )
}
